import { useState, useEffect, useRef, useContext } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faChevronDown, faXmark } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Logo from '../components/Logo.jsx'
import { AppContext } from '../context'
import { findContact } from '../utils/findContact.js'
import classNames from 'classnames'
import { useOnClickOutside, useTimeout } from 'usehooks-ts'

const Header = () => {
  const { token } = useContext(AppContext)
  const [ showMenu, setShowMenu ] = useState(false)
  const [ showSolutions, setShowSolutions ] = useState(false)
  const headerRef = useRef(null)
  const solutionsRef = useRef(null)
  const progressBarRef = useRef(null)
  const progressMobileBarRef = useRef(null)
  const { pathname } = useLocation()


  useEffect(() => {
    if(headerRef.current) {
      const resizeListener = window.addEventListener('resize', () => {
        if (window.innerWidth > 992) {
          setShowMenu(false)
        }
      })

      const scrollListener = window.addEventListener('scroll', () => {
        const changeBg = window.scrollY >= (window.innerHeight - headerRef.current?.clientHeight)
        const pathname = window.location.pathname

        if(pathname === '/') {
          if(changeBg) {
            headerRef.current.classList.remove('Header')
            headerRef.current.classList.add('Header--Active')
          } else {
            headerRef.current.classList.remove('Header--Active')
            headerRef.current.classList.add('Header')
          }
        }

        if(progressBarRef.current) {
          const bodyHeight = document.body?.clientHeight - window.innerHeight
          const windowScroll = window.scrollY
          const progress = Math.round((windowScroll / bodyHeight) * 100)

          progressBarRef.current.style.width = `${progress}%`
        }
        if(progressMobileBarRef.current) {
          const bodyHeight = document.body?.clientHeight - window.innerHeight
          const windowScroll = window.scrollY
          const progress = Math.round((windowScroll / bodyHeight) * 100)

          progressMobileBarRef.current.style.width = `${progress}%`
        }
      })

      return () => {
        window.removeEventListener('resize', resizeListener)
        window.removeEventListener('scroll', scrollListener)
      }
    }
  }, [headerRef])

  useEffect(() => {
    setShowMenu(false)
    if(headerRef.current) {
      if(pathname === '/') {
        headerRef.current.classList.remove('Header--Active')
        headerRef.current.classList.add('Header')
      } else {
        headerRef.current.classList.add('Header--Active')
        headerRef.current.classList.remove('Header')
      }
    }
  }, [pathname])


  const handleToggleMenu = () => {
    setShowMenu(!showMenu)
  }

  useOnClickOutside(solutionsRef, () => {
    setTimeout(() => {
      if (showSolutions) {
        setShowSolutions(false)
      }
    }, 500)
  })

  return (
    <>
      <header
        ref={headerRef}
        className='Header container-fluid px-3 px-lg-4'
      >
        <div className="Header__Progress-Container">
          <div className="Header__Progress-Bar" ref={progressBarRef}></div>
        </div>

        <div className="Header__Content container-custom">
          <NavLink to='/' title='Inicio'>
            <Logo className='Header__Logo'/>
          </NavLink>

          <nav className='Nav'>
            <div className='Nav__Links'>
              <div className='position-relative'>
                <button
                  className='Nav__Link gap-3'
                  onClick={() => setShowSolutions(!showSolutions)}
                >
                  Soluciones

                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={showSolutions ? 'rotate-90' : 'rotate-0'}
                  />
                </button>
                <div
                  className={showSolutions
                    ? 'Nav__Dropdown--Active'
                    : 'Nav__Dropdown'
                  }
                  ref={solutionsRef}
                >
                  <NavLink
                    to='/oficinas'
                    className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                    onClick={() => setShowSolutions(false)}
                    title='Oficinas'
                  >
                Oficinas
                  </NavLink>
                  <NavLink
                    to='/planes'
                    className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                    onClick={() => setShowSolutions(false)}
                    title='Planes'
                  >
                Planes
                  </NavLink>
                  <NavLink
                    to='/salas-de-reuniones'
                    className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                    onClick={() => setShowSolutions(false)}
                    title='Salas de reuniones'
                  >
                Salas de reuniones
                  </NavLink>
                  <NavLink
                    to='/eventos'
                    className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                    onClick={() => setShowSolutions(false)}
                    title='Eventos'
                  >
                Eventos
                  </NavLink>
                </div>
              </div>
              <NavLink
                to='/sedes'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                title='Oficinas'
              >
                Sedes
              </NavLink>
              <NavLink
                to='/comunidad'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                title='Salas de Reuniones'
              >
                Comunidad
              </NavLink>
              <NavLink
                to='/nosotros'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                title='Eventos'
              >
                Nosotros
              </NavLink>
            </div>
          </nav>

          {token
            ? <NavLink
              to='/panel/'
              className={'Nav__Link--Special'}
              title='Panel'
            >
              Panel
            </NavLink>
            : <NavLink
              to='/iniciar-sesion'
              className={'Nav__Link--Special'}
              title='Iniciar Sesión'
            >
              Iniciar Sesión
            </NavLink>
          }
        </div>
      </header>

      <header className="Header-Mobile container-custom">
        <div className="Header__Progress-Container">
          <div className="Header__Progress-Bar" ref={progressMobileBarRef}></div>
        </div>
        <div className='Header-Mobile__Bar'>
          <NavLink to='/' title='Inicio'>
            <Logo className='Header__Logo'/>
          </NavLink>

          <div className="Header__Button-Container">
            {/* <a
              className='Header__Button'
              href={`https://api.whatsapp.com/send?phone=${findContact(networks, 'whatsapp')}&text=${encodeURIComponent('Hola Vida Cowork 🍃 Visité su página web y quisiera más info de:')}`}
              aria-label='Whatsapp'
              target='_blank'
              rel='noreferrer'
            >
              <FontAwesomeIcon icon={faWhatsapp}/>
            </a> */}
            <button
              className='Header__Button'
              onClick={handleToggleMenu}
              aria-label='Menu'
              role='button'
            >
              {showMenu
                ? <FontAwesomeIcon icon={faXmark}/>
                : <FontAwesomeIcon icon={faBars}/>
              }
            </button>
          </div>
        </div>

        {showMenu && (
          <div className='Header-Mobile__Content'>
            <NavLink
              to='/'
              className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
              title='Inicio'
            >
              Inicio
            </NavLink>

            <button
              className={showSolutions
                ? 'Nav__Link--Active d-flex justify-content-between'
                : 'Nav__Link d-flex justify-content-between'
              }
              onClick={() => setShowSolutions(!showSolutions)}
            >
              Soluciones

              <FontAwesomeIcon
                icon={faChevronDown}
                className={showSolutions ? 'rotate-90' : 'rotate-0'}
              />
            </button>
            <div
              className={showSolutions
                ? 'Nav__Dropdown--Active'
                : 'Nav__Dropdown'
              }
            >
              <NavLink
                to='/oficinas'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                onClick={() => setShowSolutions(false)}
                title='Oficinas'
              >
                Oficinas
              </NavLink>
              <NavLink
                to='/planes'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                onClick={() => setShowSolutions(false)}
                title='Planes'
              >
                Planes
              </NavLink>
              <NavLink
                to='/salas-de-reuniones'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                onClick={() => setShowSolutions(false)}
                title='Salas de reuniones'
              >
                Salas de reuniones
              </NavLink>
              <NavLink
                to='/eventos'
                className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
                onClick={() => setShowSolutions(false)}
                title='Eventos'
              >
                Eventos
              </NavLink>
            </div>

            <NavLink
              to='/sedes'
              className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
              title='Sedes'
            >
              Sedes
            </NavLink>

            <NavLink
              to='/comunidad'
              className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
              title='Comunidad'
            >
              Comunidad
            </NavLink>

            <NavLink
              to='/nosotros'
              className={({ isActive }) => isActive ? 'Nav__Link--Active' : 'Nav__Link'}
              title='Nosotros'
            >
              Nosotros
            </NavLink>

            <div className='Nav__Links--Special'>
              {token
                ? <NavLink
                  to='/panel/'
                  className={'Nav__Link--Panel'}
                  title='Panel'
                >
                  Panel
                </NavLink>
                : <NavLink
                  to='/iniciar-sesion'
                  className={'Nav__Link--Panel'}
                  title='Iniciar Sesión'
                >
                  Iniciar Sesión
                </NavLink>
              }
            </div>
          </div>
        )}
      </header>
    </>
  )
}

export default Header